import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmarDatosRegistroData {
    nombrePersona: string;
    apellidoPersona: string;
    identificacion: string;
    telefono: string;
    email: string;
}

@Component({
    selector: 'app-confirmar-datos-registro',
    templateUrl: './confirmar-datos-registro.component.html',
    styleUrls: ['./confirmar-datos-registro.component.scss'],
})
export class ConfirmarDatosRegistroComponent {

    constructor(
        public dialogRef: MatDialogRef<ConfirmarDatosRegistroComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmarDatosRegistroData,
    ) {}

    confirmar() {
        this.dialogRef.close(true);
    }

    editar() {
        this.dialogRef.close(false);
    }
}
